<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2ecafb/tc-custom/9781250086846.jpg?1738254579901" alt="This image is the cover for the book Circle of Jinn, Becoming Jinn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Circle of Jinn, Becoming Jinn
      </h1>
      <p class="bookDescription body article font2">
        <p>Being Jinn is Azra's new reality. As she grants wishes under the  watchful eye of the Afrit council, she remains torn between her two  worlds—human and Jinn. Soon secrets spill, and rumors of an uprising  become real as the Afrit's reach extends beyond the underground world of  Janna.<br/><br/>Straddling the line becomes impossible. Aware of her  unique abilities, Azra must not just face but embrace her destiny. But  when the role she must play and those she must protect expand to include  a circle of Jinn greater than her own, Azra will be forced to risk  everything. A risk that means there's everything to lose, and at the  same time, everything to gain—for herself and her entire Jinn race.<br/><br/>In this dramatic sequel to Lori Goldstein's <i>Becoming Jinn</i>, Azra's story comes to a heartfelt and thrilling conclusion.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lori Goldstein
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Feiwel and Friends
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e2dc857